import { Components, Theme } from '@mui/material/styles';
import { radii } from '../foundations/tokens';
export const MuiInputBase: Components<Theme>['MuiInputBase'] = {
  styleOverrides: {
    root: { margin: 0, fontSize: 14 },
    input: ({ theme }) => ({
      '&::placeholder': { color: theme.palette.text.secondary, opacity: 1 },
    }),
  },
};
export const MuiOutlinedInput: Components<Theme>['MuiOutlinedInput'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      borderRadius: radii.md,
      backgroundColor: theme.palette.studio.surfaces.trackSoft,
      boxShadow: theme.palette.studio.shadows.controlInset,
      transition: theme.transitions.create(['background-color', 'box-shadow']),
      '&:hover .MuiOutlinedInput-notchedOutline': {
        borderColor: theme.palette.studio.borders.control,
      },
      '&.Mui-focused': {
        boxShadow: `${theme.palette.studio.shadows.controlInset},${theme.palette.studio.shadows.focusRing}`,
      },
      '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderWidth: 1 },
      '&.Mui-error': { boxShadow: 'none' },
      '&.Mui-error .MuiOutlinedInput-notchedOutline': {
        borderColor: theme.palette.error.main,
      },
      '&.Mui-disabled': {
        backgroundColor: theme.palette.action.disabledBackground,
      },
    }),
    notchedOutline: ({ theme }) => ({
      borderColor: theme.palette.studio.borders.subtle,
      top: 0,
      '& legend': { display: 'none' },
    }),
    input: {
      padding: '8px 11px',
      '&.MuiInputBase-inputSizeSmall': {
        padding: '6px 10px',
        fontSize: 13,
        lineHeight: '18px',
        height: '18px',
      },
    },
  },
};
export const MuiFilledInput: Components<Theme>['MuiFilledInput'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      margin: 0,
      backgroundColor: theme.palette.studio.surfaces.fillWeak,
      boxShadow: theme.palette.studio.shadows.controlInset,
    }),
    input: {
      paddingTop: 9,
      paddingBottom: 8,
    },
  },
};
